import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import {
  VrLicensesQueryArgs,
  getVrLicenses,
  VrLicenseData
} from './api/queries/vr-licenses'

export function useVrLicenses(organizationUuid: string) {
  const { data, isLoading, error } = useContrastQuery<
    VrLicensesQueryArgs,
    VrLicenseData
  >([Query.VR_LICENSES, organizationUuid], getVrLicenses, {
    organizationUuid
  })

  return {
    vrLicensesData: data,
    isLoading,
    error
  }
}
